import React from 'react';
import './luckObservation.css';
import MediaQuery from 'react-responsive';
import TopWonNLoss from './TopWonNLoss';
import { withRouter } from 'react-router-dom';
import LuckObservation from './LuckObservation';
import { apiService } from '../../common/apiCallService';
import { baseUrl } from '../../common/config.js';
import Loading from '../Loading';
import $ from 'jquery';
import EditNoteModal from '../HandHistory/EditNoteModal';
import StartHandsOrAggression from './StartHandsOrAggression'
import ReplayHand from '../HandReplayer/ReplayHand';
import HandReplayer from '../HandReplayer/HandReplayer';
import { saveActivity } from '../../common/commonService';
import { DispatcherFunction } from 'mygame-components';
import { getColor, getTextColor } from '../../common/ThemeService';

class Observations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openHandRep: false,
            subHeadingWon: 'When playing starting hands as advised.',
            subHeadingLost: 'When playing starting hands outside the advised range.',
            activeObservation: [1],
            latestActiveObservation: 1,
            preFlopAggression: false,
            viewTopHands: false,
            gameType: props.gameType,
            ringType: props.ringType,
            totalHandPlayed: props.totalHandPlayed,
            observations: [
                {
                    id: 1,
                    observation: 'Starting Hands',
                    subHeadingWon: 'When playing starting hands as advised.',
                    subHeadingLost: 'When playing starting hands outside the advised range.'
                },
                // {
                //     id: 2,
                //     observation: "Aggression",
                //     subHeadingWon: "whenplayingpreflop",
                //     subHeadingLost: "whenyouplayedpreflop"
                // },
                {
                    id: 3,
                    observation: 'Luck',
                    subHeadingWon: 'When playing All-In correctly.',
                    subHeadingLost: 'When playing All-In incorrectly.'
                }
            ],
            loading: false,
            currentEditNotesHand: null,
            showTopButton: false,
            showNoteModal: false,
            handList: {},
            topHandList: {},
            accountName: localStorage.getItem('accountName'),
            activeBtn: 'Won'
        }
    }

    componentDidMount() {
        let activeData = this.state.observations.filter((obj) => obj.id === this.state.activeObservation[0])[0]
        this.setState({
            activeObservation: this.state.activeObservation,
            subHeadingWon: activeData.subHeadingWon,
            subHeadingLost: activeData.subHeadingLost
        })
    }

    componentDidUpdate() {
       let spinObservations = [
            // {
            //     id: 2,
            //     observation: "Aggression",
            //     subHeadingWon: "whenplayingpreflop",
            //     subHeadingLost: "whenyouplayedpreflop"
            // },
            {
                id: 3,
                observation: 'Luck',
                subHeadingWon: 'When playing All-In correctly.',
                subHeadingLost: 'When playing All-In incorrectly.'
            }
        ];
        let observations = [
            {
                id: 1,
                observation: 'Starting Hands',
                subHeadingWon: 'When playing starting hands as advised.',
                subHeadingLost: 'When playing starting hands outside the advised range.'
            },
            // {
            //     id: 2,
            //     observation: "Aggression",
            //     subHeadingWon: "whenplayingpreflop",
            //     subHeadingLost: "whenyouplayedpreflop"
            // },
            {
                id: 3,
                observation: 'Luck',
                subHeadingWon: 'When playing All-In correctly.',
                subHeadingLost: 'When playing All-In incorrectly.'
            }
        ];
        let  latestActiveObservation = this.props.gameType === "spin" ? 3 : 1;
              let preFlopAggression= this.props.gameType === "spin" ? true :false;
              let activeObservation= this.props.gameType === "spin" ? [3] :[1];
        if (this.state.gameType != this.props.gameType) {
            if(this.props.gameType === "spin"){
                this.setState({ gameType: this.props.gameType,observations:spinObservations,latestActiveObservation,preFlopAggression,activeObservation })
            }else{
                this.setState({ gameType: this.props.gameType,observations:observations,latestActiveObservation,preFlopAggression,activeObservation })
            }
            if (this.state.activeObservation.includes(3) || this.props.gameType === "spin"){
                this.getHands(this.state.observations.filter((obj) => obj.id === 3)[0].observation)
            }
        }
    }

    learnMore = () => {
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = "ClickAggressionTabLearnPostFlop";
        track.hit_attribute1 = this.props.gameType;
        saveActivity(track);
        if (this.state.activeObservation.includes(2))
            this.props.history.push(`/reportCardCourse/Aggression?source=live-view&lessons=Aggression&accountName=${localStorage.getItem("accountName")}`)
    }

    getHands = (observation) => {
        this.setState({ loading: true })
        apiService(`${baseUrl}/reportCard/getLast48HoursAllInHands`,
            {
                gameType: this.props.gameType,
                gameSubType: 'Texas Holdem',
                ringType: this.props.ringType,
                observation: observation,
                accountName: localStorage.getItem("accountName"),
            },
            async (data) => {
                let gameNumbers = [];
                let handInfoList = [];
                data.topWonHands.map(hand => {
                    gameNumbers.push(hand.gameNo)
                })
                data.topLostHands.map(hand => {
                    gameNumbers.push(hand.gameNo)
                })
                let reqObj2 = {
                    gameType: this.props.gameType,
                    accountName: localStorage.getItem("accountName"),
                    gameNumbers,
                }
                await new Promise((resolve, reject) => {
                    apiService(baseUrl + '/handInfo/getHandInfoList', reqObj2, (resultData) => {
                        if (resultData) {
                            handInfoList = resultData
                        }
                        resolve()
                    }, (error) => {
                        reject()
                        console.log("Error", error)
                    })
                })
                data.topWonHands = data.topWonHands.map(hand => {
                    hand.notes = [];
                    hand.staredHand = false;
                    handInfoList.map(handInfo => {
                        if (handInfo.gameNo.toString() === hand.gameNo.toString() &&
                            handInfo.time === hand.time) {
                            hand.notes = handInfo.notes;
                            hand.staredHand = handInfo.staredHand;
                        }
                    })
                    return hand
                })
                data.topLostHands = data.topLostHands.map(hand => {
                    hand.notes = [];
                    hand.staredHand = false;
                    handInfoList.map(handInfo => {
                        if (handInfo.gameNo.toString() === hand.gameNo.toString() &&
                            handInfo.time === hand.time) {
                            hand.notes = handInfo.notes;
                            hand.staredHand = handInfo.staredHand;
                        }
                    })
                    return hand
                })
                this.setState({
                    loading: false,
                    handList: data
                })
                if (observation === 'Luck')
                    this.setState({ topHandList: data })
            }, (error) => {
                this.setState({
                    loading: false,
                    handList: { topWonHands: [], topLostHands: [], handAgg: {} }
                })
                console.log("Error:", error)
            })
    }

    seeMoreHands = (id) => {
        let activeData = this.state.observations.filter((obj) => obj.id === id)[0]
        this.setState({
            subHeadingWon: activeData.subHeadingWon,
            subHeadingLost: activeData.subHeadingLost
        })

        window.scrollTo(0, 0)
        if (id === 1) {
            let track = {}
            track.hit_page = 'HomePage';
            track.hit_type = "ClickStartingHandsTabViewHands";
            track.hit_attribute1 = this.props.gameType;
            saveActivity(track);
            this.getHands("Starting Hands");
        } else if (id === 2) {
            let track = {}
            track.hit_page = 'HomePage';
            track.hit_type = "ClickAggressionTabViewHands";
            track.hit_attribute1 = this.props.gameType;
            saveActivity(track);
            this.getHands("Aggression");
        }
        this.setState({ viewTopHands: true })
    }

    onCloseSeeMoreHands = () => {
        this.setState({ viewTopHands: false })
    }
    saveTrackingForObservation = (hitType) => {
        let track = {}
        track.hit_page = 'HomePage';
        track.hit_type = hitType;
        track.hit_attribute1 = this.props.gameType;
        saveActivity(track);
    }
    setActiveObservation = (id) => {
        console.log("onClick called");
        switch (id) {
            case 1:
                this.saveTrackingForObservation("ClickStartingHandsTab");
                break;
            case 2:
                this.saveTrackingForObservation("ClickAggressionTab");
                break;
            case 3:
                this.saveTrackingForObservation("ClickLuckTab");
                break;
        }

        let activeObservation = this.state.activeObservation,
            activeData = this.state.observations.filter((obj) => obj.id === id)[0]
        this.setState({ latestActiveObservation: id })

        if (!this.state.activeObservation.includes(id)) {
            activeObservation.push(id)
            this.setState({
                latestActiveObservation: id,
                activeObservation: activeObservation,
                subHeadingWon: activeData.subHeadingWon,
                subHeadingLost: activeData.subHeadingLost,
                activeBtn: 'Won',
                preFlopAggression: id === 2
            })
            if (id === 3)
                this.getHands(activeData.observation)
        } else {
            var index = activeObservation.indexOf(id);
            activeObservation.splice(index, 1);
            this.setState({ activeObservation: activeObservation })
        }
    }




    setShowNoteModal = () => {
        this.setState({ showEditModal: false })
    }

    openNotes = (hand) => {
        this.setState({
            currentEditNotesHand: hand,
        }, () => {
            if (hand.notes && hand.notes.length > 3) {
                setTimeout(() => {
                    $("#EditNoteModal_modalBody").scrollTop(hand.notes.length * 68)
                }, 500)
            }
        });
        this.setShowNoteModal(true)
    }

    setShowNoteModal = (value) => {
        this.setState({ showNoteModal: value })
    }

    addNote = (noteMsg) => {
        this.apiCallMethod(noteMsg, "Add")
    }

    editNote = (noteMsg, noteId) => {
        this.apiCallMethod(noteMsg, "Edit", noteId);
    }

    deleteNote = (noteId) => {
        this.apiCallMethod(null, "Delete", noteId);
    }


    apiCallMethod = (noteMsg, type, noteId) => {
        saveActivity({
            hit_page: 'HomePage',
            hit_type: 'Notes',
            hit_attribute1: type,
            hit_attribute2: this.state.currentEditNotesHand.gameType,
            hit_attribute3: this.state.currentEditNotesHand.gameNo,
        })
        this.setState({ loading: true })
        let reqObj = {
            gameType: this.state.currentEditNotesHand.gameType,
            gameNo: this.state.currentEditNotesHand.gameNo,
            time: this.state.currentEditNotesHand.time,
            note: noteMsg,
            accountName: localStorage.getItem("accountName"),
            user: localStorage.getItem("first_name") ? localStorage.getItem("first_name") : "",
        }
        let URL = '/handInfo/addHandNote';
        if (type === "Edit" || type === "Delete") {
            reqObj.noteId = noteId;
            if (type === "Delete") {
                reqObj.isDelete = true;
            }
            URL = '/handInfo/editOrDeleteHandNote';
        }
        apiService(baseUrl + URL, reqObj,
            (data) => {
                this.setState({ loading: false });
                let updatedHandObj = this.state.currentEditNotesHand;
                updatedHandObj.notes = data.notes;
                let topHandList = this.state.handList[`top${this.state.activeBtn}Hands`].map((hand) => {
                    if (hand.gameNo === this.state.currentEditNotesHand.gameNo && this.state.currentEditNotesHand.time === hand.time) {
                        return updatedHandObj
                    } else {
                        return hand
                    }
                })
                this.setState({ currentEditNotesHand: updatedHandObj, [`handList.top${this.state.activeBtn}Hands`]: topHandList }, () => {
                    if (type === "Add" && updatedHandObj.notes && updatedHandObj.notes.length > 3) {
                        $("#EditNoteModal_modalBody").scrollTop(updatedHandObj.notes.length * 68)
                    }
                })
            }, (error) => {
                console.log("Error:", error)
                this.setState({ loading: false })
            })
    }

    setStarFlagOfHnad = (hand, newStarValue) => {
        let reqObj = {
            staredHand: newStarValue,
            accountName: localStorage.getItem("accountName"),
            gameType: hand.gameType,
            gameNo: hand.gameNo,
            time: hand.time,
        }
        let topHandList = this.state.handList[`top${this.state.activeBtn}Hands`].map((handObj) => {
            if (handObj.gameNo === hand.gameNo && handObj.time === hand.time) {
                handObj.staredHand = newStarValue;
                return handObj
            } else {
                return handObj
            }
        })
        this.setState({ [`handList.top${this.state.activeBtn}Hands`]: topHandList })
        apiService(baseUrl + '/handInfo/setStarFlagOfHandInfo', reqObj, (data) => {
            this.setState({ loading: false });
            saveActivity({
                hit_page: 'HomePage',
                hit_type: 'FavouriteHand',
                hit_attribute1: hand.gameType,
                hit_attribute2: newStarValue,
                hit_attribute3: hand.gameNo,
                hit_attribute4: hand.time
            })
        }, (error) => {
            console.log("Error", error)
            this.setState({ loading: false })
        })
    }
    handReplayerOpen = (hand) => {
        saveActivity({
            hit_page: 'HomePage',
            hit_type: 'HomePageGameReplay',
            hit_attribute1: this.props.gameType,
            hit_attribute3: hand.gameNo,
            hit_attribute4: hand.fullDateTime? hand.fullDateTime: hand.time
        })
        if(window.messageToNative || (window.external && window.external.NativeDispatch)){
            DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
                "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
                `/PopUpHandReplayer/${this.props.gameType}/${hand.gameNo}/${this.state.accountName}/${hand.fullDateTime? hand.fullDateTime: hand.time}` ,
                "location":"yes",
                "height":"720",
                "width":"1000",
                "scrollbars":"yes",
                "status":"yes"
          })}
            else{
        this.setState({ hand }, () => { this.setState({ openHandRep: true }) });
            }
    }

    render() {
        console.log('propssss',this.props);
        let fullVersion = 0,
            hand = { ...this.state.hand },
            { gameType, ringType } = this.props,
            { observations, activeObservation, totalHandPlayed, latestActiveObservation, topHandList } = this.state

        if (navigator.appVersion.includes("Mac")) {
            if (navigator.appVersion.includes("Mobile")) {
                let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
                if (fullVersion > 12.10) {
                    fullVersion = 13
                } else {
                    fullVersion = 12
                }
            } else {
                let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                if(osVersion !=null) {
                    fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
                    if (fullVersion > 10.13) {
                        fullVersion = 13
                    } else {
                        fullVersion = 12
                    }
                }else {
                    fullVersion = 13;
                }
               
            }
        } else {
            fullVersion = 13;
        }

        const themeColor = getColor()
        const themeTextColor = getTextColor()
        return (
            <div className="base_home_observations homePageLand1Col">
                {this.state.loading ? <Loading /> : null}
                {this.state.openHandRep ? <div style={{
                    top: 0,
                    left: 0,
                    zIndex: 20000,
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                    position: "fixed",
                    backgroundColor: '#2c2c34'
                }}>
                    <style>{"\
                                .navbar-fixed-top{\
                                z-index:0 !important;\
                                }\
                            "}</style>
                    {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
                        replayerScreen={'desktop'}
                        gameTypeForTitle={hand.gameType}
                        onClose={() => this.setState({ openHandRep: false })}
                        loginStatus={true}
                        gameNo={hand.gameNo}
                        accountName={localStorage.getItem('accountName')}
                        partitionDate={hand.time}
                    /> :
                        <ReplayHand
                            replayerScreen={'desktop'}
                            loginStatus={true}
                            gameNo={hand.gameNo}
                            partitionDate={hand.time}
                            accountName={localStorage.getItem('accountName')}
                            gameTypeForTitle={hand.gameType}
                            onClose={() => this.setState({ openHandRep: false })}
                        />}
                </div> : null}
                <EditNoteModal
                    hand={this.state.currentEditNotesHand}
                    addNote={this.addNote}
                    editNote={this.editNote}
                    deleteNote={this.deleteNote}
                    i18next={this.props.i18next}
                    setShowNoteModal={this.setShowNoteModal} />
                {this.state.viewTopHands &&
                    <TopWonNLoss
                        activeBtn={this.state.activeBtn}
                        setActiveBtn={(value) => {
                            this.setState({ viewTopHands: false })
                            this.setState({ activeBtn: value }, () => {
                                this.setState({ viewTopHands: true })
                            })
                        }}
                        handList={this.state.activeBtn === "Won"
                            ? (this.state.handList.topWonHands ? this.state.handList.topWonHands : [])
                            : this.state.handList.topLostHands ? this.state.handList.topLostHands : []}
                        subHeadingWon={this.state.subHeadingWon}
                        subHeadingLost={this.state.subHeadingLost}
                        openNotes={this.openNotes}
                        setStarFlagOfHnad={this.setStarFlagOfHnad}
                        handReplayerOpen={this.handReplayerOpen}
                        onCloseSeeMoreHands={this.onCloseSeeMoreHands} />}
                <div className="observations">
                    <button className="homePageEarlyObservation" disabled data-e2e="earlyObservation" >
                        Early Observations:
                    </button>

                    {observations.map((obj,index) =>
                        <span key={'observation-' + obj.id}>
                            {console.log("obj.id === latestActiveObservation",obj.id,latestActiveObservation,obj.id === latestActiveObservation)}
                            <button data-e2e={obj.observation}
                                className={`homePageEarlyObservationBtns ${obj.id === latestActiveObservation ? ' activeObservationBtn' : ''}`}
                                style={obj.id === latestActiveObservation ? { 
                                    backgroundColor: themeColor,
                                    color: themeTextColor
                            } : {}}
                                onClick={(e) => this.setActiveObservation(obj.id)}>
                                <MediaQuery maxWidth={1024} >{index+1}.&nbsp;{obj.observation} 
                                    <i className={`fa ${activeObservation.includes(obj.id) ? ' fa-angle-up ' : ' fa-angle-down '} mygameLandUpDownArrow`}
                                    style={{
                                        color: themeColor,
                                    }}
                                    ></i>
                                </MediaQuery>
                                <MediaQuery minWidth={1025} >{obj.observation}</MediaQuery>
                            </button>
                            <MediaQuery maxWidth={1024} >
                                <div>
                                    <div className="homePageEarlyObservation-Divider"></div>
                                    {activeObservation.includes(obj.id) &&
                                        <div>
                                            {(activeObservation.includes(obj.id) || activeObservation.includes(obj.id)) && ([1, 2].includes(obj.id))
                                                && <StartHandsOrAggression 
                                                    gameType={gameType}
                                                    ringType={ringType}
                                                    learnMore={this.learnMore}
                                                    seeMoreHands={() => this.seeMoreHands(obj.id === 2 ? 2 : 1)}
                                                    preFlopAggression={obj.id === 2}
                                                    totalHandPlayed={totalHandPlayed} />}
                                            {activeObservation.includes(obj.id) && !([1, 2].includes(obj.id)) && Object.keys(topHandList).length > 0
                                                && <LuckObservation
                                                    handList={topHandList}
                                                    gameType={gameType}
                                                    ringType={ringType}
                                                    totalHandPlayed={totalHandPlayed}
                                                    seeMoreHands={() => this.seeMoreHands(3)}
                                                    openNotes={this.openNotes}
                                                    setStarFlagOfHnad={this.setStarFlagOfHnad}
                                                    handReplayerOpen={this.handReplayerOpen}
                                                    onCloseSeeMoreHands={this.onCloseSeeMoreHands} />}
                                        </div>
                                    }
                                </div>
                            </MediaQuery>
                        </span>
                    )}
                </div>
                <MediaQuery minWidth={1025} >
                    <div>
                        <div className="homePageEarlyObservation-Divider"></div>
                        {(latestActiveObservation === 1 || latestActiveObservation === 2)
                            && <StartHandsOrAggression
                                gameType={this.props.gameType}
                                ringType={ringType}
                                learnMore={this.learnMore}
                                seeMoreHands={() => this.seeMoreHands(1)}
                                preFlopAggression={latestActiveObservation === 2}
                                totalHandPlayed={this.props.totalHandPlayed} />}
                        {latestActiveObservation === 3 && Object.keys(topHandList).length > 0
                            && <LuckObservation
                                gameType={gameType}
                                handList={topHandList}
                                ringType={ringType}
                                totalHandPlayed={totalHandPlayed}
                                seeMoreHands={() => this.seeMoreHands(3)}
                                openNotes={this.openNotes}
                                setStarFlagOfHnad={this.setStarFlagOfHnad}
                                handReplayerOpen={this.handReplayerOpen}
                                onCloseSeeMoreHands={this.onCloseSeeMoreHands} />}
                    </div>
                </MediaQuery>
            </div >
        )
    }
}

export default withRouter(Observations);


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Observations.js
 **/